import axios from 'axios'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { setMessage } from '../message/messageSlice'
import { setInputError } from '../inputError/inputErrorSlice'

const endPoint = process.env.REACT_APP_API_URL

export const getMinersOwned = createAsyncThunk(
    "getMinersOwned",
    async({user}, rejectWithValue) => {
        try {
            const config = {
                headers: {
                  'Authorization': `Bearer ${localStorage.getItem("token")}`
                  
                },
              }
              const res = await axios.get(
                `${endPoint}/equipements/?user=${user.id}`,
                config
              )
              return res
        } catch (error) {
            console.log(error)
        }
    }
)

export const buyMiner = createAsyncThunk(
    "buyMiner",
    async({user, machine, quantity}, thunkApi) => {
        try {
            const config = {
                headers: {
                  'Authorization': `Bearer ${localStorage.getItem("token")}`
                  
                },
              }
              const res = await axios.post(
                `${endPoint}/equipements/`,
                {user, machine, quantity, order_type: "buy"},
                config
              )
              return res
        } catch (error) {
          const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
          thunkApi.dispatch(setMessage(message));
          thunkApi.dispatch(setInputError(error.response && error.response.data));
          return thunkApi.rejectWithValue(await error.json());
        }
    }
)

export const activateMiner = createAsyncThunk(
    "activateMiner",
    async({user, data}, thunkApi) => {
        try {
            const config = {
                headers: {
                  'Authorization': `Bearer ${localStorage.getItem("token")}`
                  
                },
              }
              const res = await axios.post(
                `${endPoint}/re_activate_machine/`,
                data,
                config
              )
              return res
        } catch (error) {
          const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
          thunkApi.dispatch(setMessage(message));
          thunkApi.dispatch(setInputError(error.response && error.response.data));
          return thunkApi.rejectWithValue(await error.json());
        }
    }
)

export const sellMiner = createAsyncThunk(
    "sellMiner",
    async({user, machine, quantity}, thunkApi) => {
        try {
            const config = {
                headers: {
                  'Authorization': `Bearer ${localStorage.getItem("token")}`
                  
                },
              }
              const res = await axios.post(
                `${endPoint}/equipements/`,
                {user, machine, quantity, order_type: "sell"},
                config
              )
              return res
        } catch (error) {
          const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
          thunkApi.dispatch(setMessage(message));
          thunkApi.dispatch(setInputError(error.response && error.response.data));
          return thunkApi.rejectWithValue(await error.json());
        }
    }
)